import { useState } from "react";
import { faqItems } from "@/mocks/faq";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="font-bebas text-sm tracking-[0.2em] text-primary-500">FAQ</p>
          <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
            吃瓜常见问题 · <span className="text-primary-500">先看清再站队</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            关于哇偶姐姐的争议、数据来源与围观方式，这里整理了围观网友最常问的问题。
          </p>
        </div>

        <div className="mt-9 space-y-3">
          {faqItems.map((f) => {
            const open = openId === f.id;
            return (
              <div
                key={f.id}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                  open ? "border-primary-200" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? null : f.id)}
                  className="flex w-full items-center gap-4 p-5 text-left"
                  aria-expanded={open}
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {String(f.id).padStart(2, "0")}
                  </span>
                  <span className={`flex-1 text-[15px] font-medium ${open ? "text-foreground-950" : "text-foreground-800"}`}>
                    {f.q}
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-xl transition-transform duration-300 ${open ? "rotate-45 text-primary-500" : "text-foreground-400"}`}
                    aria-hidden="true"
                  />
                </button>
                {open && (
                  <p className="border-t border-background-200 px-5 pb-5 pl-[72px] pr-6 pt-4 text-sm leading-7 text-foreground-700">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}